<!--
  What a file's diff lacks because the engine failed computing it in full
  (diff/fileBlocks.ts): a quiet line above the diff, which is
  still shown, with Try again and the failure behind Details (Copy
  details, Send feedback).
-->
<script lang="ts">
  import { rememberedWords, shortfallWords, type Shortfall } from '../diff/fileBlocks';
  import FailureDetails from './FailureDetails.svelte';

  let { shortfall, path, onretry }: { shortfall: Shortfall; path: string; onretry?: () => void } = $props();
  const remembered = $derived(rememberedWords(shortfall));
</script>

<div class="shortfall" role="note">
  <p>
    <span class="muted">{shortfallWords(shortfall)}</span>
    {#if remembered}<span class="muted">{remembered}</span>{/if}
    {#if onretry}<button class="btn small" type="button" onclick={onretry}>Try again</button>{/if}
  </p>
  <FailureDetails
    failure={shortfall.failure}
    what={path}
    note={shortfall.remembered ? `Not tried again this session: it failed at ${new Date(shortfall.failure.at).toISOString()}.` : undefined}
  />
</div>

<style>
  .shortfall {
    display: grid;
    gap: 4px;
    padding: 8px 12px;
    margin-bottom: 8px;
    border: 1px dashed var(--line);
    border-radius: 8px;
    font-size: 13px;
    min-width: 0;
  }
  .shortfall p {
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 4px 8px;
    align-items: baseline;
  }
</style>
